<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
            <v-flex sm12 md12 lg10>

                <v-slide-x-transition mode="out-in">
                    <TableComponent transition="slide-x-transition" v-show="tableView" :tableData="myScheduleData" :titleColor="getTitleColorStore">
                        <switchButton slot="actions" :tableView="tableView" @buttonEvent="switchComponents"></switchButton>
                    </TableComponent>
                </v-slide-x-transition>
                <v-slide-x-transition mode="out-in">
                    <MyScheduleTimeline transition="slide-x-transition" v-show="!tableView" :timelineData="myScheduleData" :titleColor="getTitleColorStore">
                        <switchButton slot="actions" :tableView="tableView" @buttonEvent="switchComponents"></switchButton>
                    </MyScheduleTimeline>
                </v-slide-x-transition>
            </v-flex>
            <v-flex sm12 md12 lg8>

            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    //import ProgressBar from '../Common/Components/MyToolbarProgressBar.vue';
    import TableComponent from './schedule_components/MyScheduleTableComp.vue';
    import MyScheduleTimeline from './schedule_components/MyScheduleTimeline.vue';
    import { mapState, mapGetters, mapMutations } from 'vuex';
    import switchButton from './schedule_components/mySwitchButton.vue';

    export default {
        name: 'MyScheduleView',
        props: {


        },
        computed: {
            ...mapState('myScheduleModule', ['MySchedule']),
            ...mapGetters({ getTitleColorStore: 'app/getTitleColor' }),

            loading: {
                get: function () {
                    return this.myScheduleData.length == 0;
                }
            },

        },
        data() {
            return {
                tableView: false,
                tabs: 0,
                list: {
                    0: false,
                    1: false,
                    2: false
                },
                myScheduleData: [],
                pagination: {
                    rowsPerPage: 10
                }
            }
        },
        mounted() {
            var self = this;
            this.$fetchDataPromise('/api/Education/GetMySchedule', null)
                .then(function (data) {
                    self.myScheduleData = data;
                    //self.SET_MY_SCHEDULE(data); // Za sada ove podatke ne trebamo dijeliti
                    if (data.length == 0) {
                        self.myScheduleData = [{
                            Datum: '', Ime: 'Nema podataka', IndexBojeTimelinea: 0
                        }]
                    }
                })
                .catch(x => this.$displayError(x));
        },
        methods: {
            ...mapMutations('myScheduleModule', ['SET_MY_SCHEDULE']),
            switchComponents() {
                this.tableView = !this.tableView
            }
        },
        components: {
            TableComponent, MyScheduleTimeline, switchButton
        }
    }
</script>


<style>
    td ul {
        list-style-type: none;
        padding: 0;
    }

    .v-icon-fix .v-icon {
        /*color: #999 !important;*/ /* Iz nekog razloga defaultni css ne radi...*/
    }
</style>



// WEBPACK FOOTER //
// VueSrc/Education/MyScheduleView.vue